import { CommonPageTDK, DynamicHead } from '@lemon8/web-app-shared/ssr';
import { FC } from 'react';
import { useHomepageTDK } from '~/utils/use-page-tdk';
import { RegionFallbackLanguageMap } from '@lemon8/web-app-shared/i18n';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';

export const CanonicalHrefLangs = ['ja-JP', 'th-TH', 'ms-MY', 'id-ID', 'vi-VN', 'en-US', 'en-GB', 'en-SG'] as const;

export const getCanonicalUrl = () => {
  const { region } = useAtomValue($Locale);
  return `https://www.lemon8-app.com/${RegionFallbackLanguageMap[region]}-${region.toUpperCase()}`;
};

const CanonicalLinkComponent: FC = () => {
  const canonicalUrl = getCanonicalUrl();
  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={'https://www.lemon8-app.com'} />
      {CanonicalHrefLangs.map((lng) => (
        <link key={lng} rel="alternate" hrefLang={lng} href={`https://www.lemon8-app.com/${lng}`} />
      ))}
    </DynamicHead>
  );
};

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <CanonicalLinkComponent />;
}

export const HomepageTDK = () => {
  return <PageTDK {...useHomepageTDK()} />;
};
